import { queryClient } from "../../api";
import { useQRStore } from "../../store/qrStore";
import { useCardsStore } from "../../store/cardsStore";
import { usePersistStore } from "../../store/persistStore";
import { usePinFormStore } from "../../store/pinFormStore";
import { usePaymentsStore } from "../../store/paymentsStore";
import { useLoginFormStore } from "../../store/loginFormStore";
import { useSbpTransferStore } from "../../store/sbpTransferStore";
import { useTransferFormStore } from "../../store/transferFormStore";
import { usePartialPaymentStore } from "../../store/partialPaymentStore";
import { useCardIssuanceFormStore } from "../../store/cardIssuanceFormStore";
import { useOperationListFiltersStore } from "../../store/operationListFiltersStore";
import { useAuthorizationStore, AuthorizationVersion } from "../../store/authorizationStore";

export function clearAuthorization(version = useAuthorizationStore.getState().version, keepDevice = false) {
  const previous = useAuthorizationStore.getState();
  useAuthorizationStore.setState({
    version,
    token: undefined,
    refreshToken: undefined,
    deviceId: keepDevice ? previous.deviceId : undefined,
    otpSessionUuid: undefined,
    authSessionId: undefined,
    flow: undefined,
    restoringPin: false,
    passportChecked: false,
    epoch: previous.epoch + 1,
  });

  if (previous.version !== version) {
    usePersistStore.getState().setFingerprint("");
  }

  usePersistStore.getState().clearJwt();
  usePersistStore.getState().clearDeviceJwt();
  const login = useLoginFormStore.getState();
  login.clearPhoneForm();
  login.clearSMSForm();
  login.clearForm();
  usePinFormStore.getState().reset();
  void queryClient.cancelQueries();
  queryClient.clear();
  usePaymentsStore.getState().reset();
  usePartialPaymentStore.getState().reset();
  useTransferFormStore.getState().reset();
  useSbpTransferStore.getState().reset();
  useOperationListFiltersStore.getState().reset();
  useCardsStore.getState().selectCard(0);
  useQRStore.getState().setQRPayload(null);
  useCardIssuanceFormStore.getState().clearEmailForm();
  useCardIssuanceFormStore.getState().clearSMSForm();
  sessionStorage.clear();
}

export function selectAuthorization(version: AuthorizationVersion) {
  const previous = useAuthorizationStore.getState().version ?? "legacy";
  if (previous !== version) {
    clearAuthorization(version);
    return true;
  }

  useAuthorizationStore.setState({ version });
  return false;
}
